import { useState, useEffect } from 'react';
import { Tabs, Row, Col, Select, Form } from 'antd';
import { getOptionArray, selectFilterOption } from "@/lib/antdElementFunction";
import { getLangList } from '@/lib/i18n';
import StudentConfig from "@/config/student";
import ClassTimePeriodConfig from "@/config/classTimePeriod";
import SectionConfig from "@/config/section";
import YearSemesterToolBar from "@/components/YearSemesterToolBar";
import { TimePeriodType, ClassType, StudentType } from './types';
import Classes from './Classes';
import StudentSingle from './StudentSingle';

const { getAllStudent } = StudentConfig;
const { getClassTimePeriods } = ClassTimePeriodConfig;
const { getClasses } = SectionConfig;
const { TabPane } = Tabs;

type Props = {
  isRollCall: boolean;
}

function StudentManagement(props: Props) {
  const { isRollCall = false } = props;
  const [intervalArray, setIntervalArray] = useState<TimePeriodType[]>([]);
  const [selectedIntervalName, setSelectedIntervalName] = useState('');
  const [allClassObject, setAllClassObject] = useState<{ [key: string]: ClassType[] }>({});
  const [allStudentArray, setAllStudentArray] = useState<StudentType[]>([]);
  const [studentInfo, setStudentInfo] = useState({} as StudentType);
  const [form] = Form.useForm();
  const [yearSemesterForm] = Form.useForm();
  const studentListT: any = getLangList("studentList");

  useEffect(() => {
    if (Object.keys(studentInfo).length > 0) {
      const { userAccountId } = studentInfo;
      const selectedStudent = allStudentArray?.find((item: StudentType) => item.userAccountId === userAccountId) ?? {} as StudentType;
      setStudentInfo(selectedStudent);
    }
  }, [allStudentArray, studentInfo]);

  function getTimePeriodFunction(semesterId: number) {
    getClassTimePeriods({ semesterId }).then((res: any) => {
      const intervalArray = res?.value ?? [];
      setIntervalArray(intervalArray);
      setSelectedIntervalName(intervalArray[0]?.timePeriodName ?? '');
    });
  };

  const getAllClassFunction = async (semesterId: number) => {
    return getClasses({ semesterId }).then((res: any) => {
      const allClassObject = res?.value ?? {};
      setAllClassObject(allClassObject);
    });
  };

  function getAllStudentFunction(semesterId: number) {
    getAllStudent({ semesterId }).then((res: any) => {
      const allStudentArray = res?.value ?? {};
      setAllStudentArray(allStudentArray);
    });
  };

  function getUserAccountIdDataArray() {
    return allStudentArray.map((item: StudentType) => {
      const { nameCn, nameEn, className, userAccountId } = item;
      return { value: userAccountId, label: `${nameCn}-${nameEn}-${className}` }
    });
  }

  function onChangeStudent(userAccountId: number) {
    const selectedStudent = allStudentArray?.find((item: StudentType) => item.userAccountId === userAccountId) ?? {} as StudentType;
    setStudentInfo(selectedStudent);
  }

  function renderIntervalTab() {
    return intervalArray.map((item: TimePeriodType) => {
      const { timePeriodName } = item;
      const classArray = allClassObject?.[timePeriodName] ?? [];

      return (
        <TabPane key={timePeriodName} tab={timePeriodName}>
          <Classes classArray={classArray} isRollCall={isRollCall} yearSemesterForm={yearSemesterForm} />
        </TabPane >
      );
    });
  };

  return (
    <>
      <Row justify="center">
        <Col>
          <YearSemesterToolBar
            yearSemesterForm={yearSemesterForm}
            onChangeSemester={async (semesterId) => {
              await getAllClassFunction(semesterId);
              getTimePeriodFunction(semesterId);
              getAllStudentFunction(semesterId);
            }}
          />
        </Col>
      </Row>

      <Row gutter={[0, 8]} justify="center">
        {!isRollCall &&
          <Col>
            <Form form={form}>
              <Form.Item name="studentInfo" label={studentListT.PERSON_SEARCH}>
                <Select
                  showSearch
                  allowClear
                  style={{ width: "400px" }}
                  optionFilterProp="children"
                  filterOption={(input: any, option: any) => selectFilterOption(input, option)}
                  onChange={onChangeStudent}
                >
                  {getOptionArray(getUserAccountIdDataArray())}
                </Select>
              </Form.Item>
            </Form>
          </Col>
        }

        <Col span={24}>
          {Object.keys(studentInfo).length > 0
            ? <StudentSingle
              studentInfo={studentInfo}
              getAllStudentFunction={getAllStudentFunction}
            />
            : <Tabs
              size="large"
              type="card"
              onChange={setSelectedIntervalName}
              activeKey={selectedIntervalName}
              destroyInactiveTabPane
            >
              {renderIntervalTab()}
            </Tabs>
          }
        </Col>
      </Row>
    </>
  )
}

export default StudentManagement;